import { render } from "./AdminEdit.vue?vue&type=template&id=9931e5d0"
import script from "./AdminEdit.vue?vue&type=script&lang=js"
export * from "./AdminEdit.vue?vue&type=script&lang=js"

import exportComponent from "F:\\admin_om\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__